import { createContext } from "react";

export const QuizContext= createContext();